import { resetStoresState } from 'Features/SellerCommunications/services/helpers';
import { triggerSellerMessagingModalClosedEvent } from 'Services/analytics/events';

import { ModalFlowStore, ModalStore } from './stores';
import type { ModalStep } from './types';

export const onClose = () => {
	const { currentStep } = ModalFlowStore.getState();
	triggerSellerMessagingModalClosedEvent(currentStep);
	resetStoresState();
};

export const onOpen = () => ModalStore.setState({ isOpen: true });

export const onNavigate = (currentStep: ModalStep) => ModalFlowStore.setState({ currentStep });

export const modalService = {
	onClose,
	onNavigate,
	onOpen,
};
